import { render, staticRenderFns } from "./NavigationCarouselComponent.vue?vue&type=template&id=b07e76e2&scoped=true"
import script from "./NavigationCarouselComponent.vue?vue&type=script&lang=ts"
export * from "./NavigationCarouselComponent.vue?vue&type=script&lang=ts"
import style0 from "./NavigationCarouselComponent.vue?vue&type=style&index=0&id=b07e76e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07e76e2",
  null
  
)

export default component.exports